import './SettingsAccount.css'
import { useTranslation } from 'react-i18next'
import { NavLink, useNavigate } from 'react-router-dom'
import { useState } from 'react'

import GlobalStore from '../../GlobalStore'

import { Header } from '../../components/Header/Header.js'
import { BottomMenu } from '../../components/BottomMenu/BottomMenu'
import { CommunityLanguage } from '../../components/CommunityLanguage/CommunityLanguage'
import { useGetAccountQuery } from '../../redux/accountService/accountApiSlice'

const SettingsAccount = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { data = {}, error, isLoading } = useGetAccountQuery()

	const [openedTranslator, setOpenedTranslator] = useState(false)

	const handleTranslator = () => {
		setOpenedTranslator(true)
	}

	const handleLogout = () => {
		GlobalStore.clear()
		GlobalStore.setItem('logout', true)
		window.location.reload()
		navigate('/')
	}

	return (
		<>
			<Header
				className="header-container"
				backButton={true}
				subtitle={t('Account')}
				translation={true}
				openTranslator={() => handleTranslator()}
			/>

			<div className="settings-account__container">
				<div className="settings-account__wrapper">
					{
						data?.last_name &&
						<div className="settings-account__block">
							<p className="settings-account__text">
								{data?.last_name}
							</p>
						</div>
					}

					{
						data?.first_name &&
						<div className="settings-account__block">
							<p className="settings-account__text">
								{data?.first_name}
							</p>
						</div>
					}

					{/*
					{
						data?.first_name &&
							<div className="settings-account__block">
								<p className="settings-account__text">
									Олегович
								</p>
							</div>
					}
					*/}

					{/*
					{
						data?.first_name &&
							<div className="settings-account__block">
								<p className="settings-account__text">
									23.09.1985
								</p>
							</div>
					}
					*/}

					{
						data?.mobile &&
						<div className="settings-account__block settings-account__block--edit">
							<p className="settings-account__text">
								{data?.mobile}
							</p>

							{/*
								<NavLink to="" className="settings-account__confirmation">
									{t("Confirm")}
								</NavLink>
								*/}
						</div>
					}

					{
						data?.email &&
						<div className="settings-account__block">
							<p className="settings-account__text">
								{data?.email}
							</p>
						</div>
					}
				</div>

				<NavLink to="/" className="settings-account__logout" onClick={handleLogout}>
					{t('Sign out')}
				</NavLink>

				{/* <p className="settings-account__delete">
					{t('Delete account')}
				</p> */}

				{/* <NavLink to="" className="settings-account__info">
					{t('About website')}
				</NavLink> */}
			</div>

			<BottomMenu />

			{
				openedTranslator &&
				<CommunityLanguage onClose={() => setOpenedTranslator(false)} />
			}
		</>
	)
}

export default SettingsAccount
